const Menu = [
  { header: 'Services' },
  {
    text: 'My Apps',
    group: 'drlogic',
    to: '/',
    icon: 'cloud',
    children: [{ to: '/', text: 'Secure Share' }],
  },
]

export default Menu
